














import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class LevelOptions extends Vue {
  protected options: Number = 5
  protected selectedLevel: Number = 7

  protected selectOption (level: Number) {
    this.selectedLevel = level
    this.$emit('levelClicked', level)
  }
}
